import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CategoriesService } from '../shared/category/categories.service';
import { processResolver } from './process-resolver';
import { ClassFeatureComponent } from '../class/feature/class-feature.component';


const log = new LoggingService();
export const ContractClassRoute: Ng2StateDeclaration = {
    name: 'contractclass',
    url: '/contractclass',
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: ClassFeatureComponent
};
